/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { AttachmentDto } from '../../models/attachment-dto';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface GetAttachmentsByTopic$Params {
  topic: string;
}

export function getAttachmentsByTopic(
  http: HttpClient,
  rootUrl: string,
  params: GetAttachmentsByTopic$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<Array<AttachmentDto>>> {
  const rb = new RequestBuilder(rootUrl, getAttachmentsByTopic.PATH, 'get');
  if (params) {
    rb.path('topic', params.topic, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AttachmentDto>>;
    }),
  );
}

getAttachmentsByTopic.PATH = '/service/v1/attachment/{topic}';
